module.exports = __webpack_public_path__ + "908e4d2e/img/placeholder.888fcd0b.svg";